// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3vV5pe-gCAvtatYqXkdsos{list-style:none}.byk-DSJAN9H9-HAJZJwfr{padding:2.4rem 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": "_3vV5pe-gCAvtatYqXkdsos",
	"category": "byk-DSJAN9H9-HAJZJwfr"
};
module.exports = ___CSS_LOADER_EXPORT___;
